const Card = {
  baseStyle: {
    p: "22px",
    display: "flex",
    flexDirection: "column",
    backdropFilter: "blur(12px)",
    width: "100%",
    borderRadius: "16px",
    bg: "linear-gradient(145deg, rgba(13, 17, 15, 0.95) 0%, rgba(20, 30, 24, 0.85) 100%)",
    backgroundClip: "border-box",
    border: "1px solid rgba(34, 197, 94, 0.1)",
    boxShadow: "0 4px 24px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.03)",
    transition: "all 0.3s ease",
    _hover: {
      border: "1px solid rgba(34, 197, 94, 0.2)",
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.05)",
    },
  },
};

export const CardComponent = {
  components: {
    Card,
  },
};
